// DEVELOPMENT
export const environment = {
    production: false,
    identityUrl: 'https://identity-v2-dev.nside.io',
    withCredentials: true,
    angularAppUrl: 'https://rems-eop-dev.nside.io',
    apiBaseUrl: 'https://rems-eop-api-dev.nside.io',
    nSideAssessUrl: 'https://dev.nside.io/Assess.aspx'
};
